<script>
import DonationThankYouMessage from '@/components/donations/donation-thank-you-message.vue'

import fundraiserPublicFetchMixin from '@/mixins/fundraiserPublicFetchMixin.js'
import { useDonationsPublicStore } from '@/stores/donationPublic.js'
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import TwCardWithBackdrop from '@/components/generic/tw-card-with-backdrop.vue'
import TwButton from '@/components/generic/tw-button.vue'
import DonationPublicDetails from '@/components/donations/donation-public-details.vue'
import TwModal from '@/components/generic/modal/tw-modal.vue'
import FundraiserSocialsShare from '@/components/fundraisers/fundraiser-socials-share.vue'
export default {
  name: 'FundraiserDonationReturnPagePublicPage',
  components: { DonationThankYouMessage, FundraiserSocialsShare, TwModal, DonationPublicDetails, TwButton, TwCardWithBackdrop, TwLoadingSpinner, TwTransitionContainer },
  mixins:[fundraiserPublicFetchMixin],
  props: {
    donationId: {
      type: Number,
      required: true
    },
  },
  computed: {
    donation() {
      return useDonationsPublicStore().getItemById(this.donationId)
    }
  },
  mounted() {
    useDonationsPublicStore().fetchItemById(this.donationId)
    useDonationsPublicStore().processCheckout(this.donationId)
  },
  methods: {
    closed() {
      this.$router.push({ name: 'FundraiserPublicPage', params: { fundraiserId: this.fundraiser.id, slug: this.fundraiser.slug } })
    }
  }
}
</script>

<template>
  <tw-transition-container>
    <tw-card-with-backdrop v-if="fundraiser && donation" :backdrop-url="fundraiser.cover_image_url" show-close-button @close="closed">
      <donation-thank-you-message :message="fundraiser.settings?.thank_you_page_message" :donation="donation" class="mt-8" />
      <tw-button class="mt-4" variant="amber" block size="lg" @click="$refs.shareModal.open()">
        Spread the Word
      </tw-button>
      <donation-public-details :donation="donation" />
      <div class="flex justify-center mt-8 mb-4">
        <img :src="fundraiser.logo_url" class="max-h-22 max-w-40">
      </div>
      <div class="text-center text-xs">
        <i class="pi pi-lock mr-1" />Your donation is safe and secure. All proceeds of your donation will go directly to <span class="font-semibold">{{ fundraiser.cached.beneficiary_name }}</span>
      </div>
      <tw-modal ref="shareModal" ok-only ok-text="Close" variant="secondary" title="Share this fundraiser" @ok="$refs.shareModal.close()">
        <fundraiser-socials-share :fundraiser="fundraiser" />
      </tw-modal>
    </tw-card-with-backdrop>
    <tw-loading-spinner v-else />
  </tw-transition-container>
</template>

<style scoped>

</style>
